import React from 'react'

import ListChapter from './ListChapter'
import LoadingIcon from './LoadingIcon'

class Chapters extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      cookbookDescriptionOpen: false
    }
  }

  showDescription(e) {
    e.preventDefault()

    const toggleDescription = !this.state.cookbookDescriptionOpen

    this.setState((state, props) => ({
      cookbookDescriptionOpen: toggleDescription
    }))
  }

  render() {
    let cookbookTitle = ''
    let cookbookRecipesCount = ''
    let cookbookDescription = ''
    let cookbookDescriptionSection = ''

    let chapterList = ''
    let chapterItems = ''

    if (this.props.chapters !== undefined) {
      if (this.props.chapters.length > 0) {
        if (this.props.cookbook) {
          cookbookTitle = this.props.cookbook.title
          if (
            this.props.cookbook.description !== undefined &&
            this.props.cookbook.description !== ''
          ) {
            cookbookDescription = this.props.cookbook.description
          }
        }

        if (
          cookbookDescription !== undefined &&
          cookbookDescription !== null &&
          cookbookDescription !== ''
        ) {
          const cookbookDescriptionOpen = this.state.cookbookDescriptionOpen
          const HTMLCookbookDescription = { __html: cookbookDescription }
          const readMoreLink = (
            <a
              href="#"
              className="cookbook__description__read-more"
              onClick={e => {
                this.showDescription(e)
              }}
            >
              {cookbookDescriptionOpen ? 'Read less' : 'Read more'}
            </a>
          )
          cookbookDescriptionSection = (
            <div className="cookbook__description">
              <div
                className={
                  cookbookDescriptionOpen
                    ? 'cookbook__description__text open'
                    : 'cookbook__description__text'
                }
                dangerouslySetInnerHTML={HTMLCookbookDescription}
              />
              {cookbookDescription.length > 100 ? readMoreLink : ''}
            </div>
          )
        }

        let recipeCounter = this.props.chapters.reduce(function(count, item) {
          if (
            item.recipesCount !== undefined &&
            !isNaN(item.recipesCount) &&
            item.recipesCount > 0
          ) {
            return count + item.recipesCount
          } else {
            return count
          }
        }, 0)

        if (recipeCounter > 0) {
          cookbookRecipesCount = '(' + recipeCounter + ')'
        }

        chapterItems = this.props.chapters.map(item => (
          <ListChapter
            key={item.uuid}
            cookbookUrl={this.props.cookbookUrl}
            chapter={item}
          />
        ))
        chapterList = <ul className="chapter-list">{chapterItems}</ul>
      } else {
        chapterList = (
          <div className="warning text-center">No Chapters Found</div>
        )
      }
    } else {
      chapterList = (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <LoadingIcon />
        </div>
      )
    }
    return (
      <div>
        <h2 className="text-center">
          {cookbookTitle} {cookbookRecipesCount}
        </h2>
        {cookbookDescriptionSection}
        {chapterList}
      </div>
    )
  }
}

export default Chapters



// WEBPACK FOOTER //
// ./src/Components/Chapters.js